import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import {
  Button,
  MenuItem,
  Nav,
  Navbar,
  NavDropdown,
  NavItem,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import Badge from "material-ui/Badge";
import { FieldGroup, FormProps, lovValue } from "core/form/formUtils";
import { MdCheckbox } from "core/components/fields/fields";
import IconButton from "material-ui/IconButton";
import FontIcon from "material-ui/FontIcon";
import FlatButton from "material-ui/FlatButton";
import MuiMenuItem from "material-ui/MenuItem";
import MuiDivider from "material-ui/Divider";
import FileFileDownload from "material-ui/svg-icons/file/file-download";
import GridService from "core/grid/gridService";
import Grid, {
  AGGREGATETYPE_MAP,
  GridCell,
  GridParams,
  GridRow,
  GRIDTYPE,
  ROW_HEIGHT,
} from "core/grid/domain/grid";
import GridHeader from "core/grid/component/gridHeader";
import { MdIconButton, ZzIconButtonMenu } from "core/components/buttons/icons";
import { callOnObjectOrArray } from "core/common/utils/jsonUtils";
import { ErrorComp } from "core/components/errorComp/errorComp";
import { addTenantToQuery } from "core/common/utils/utils";
import { LoadingElement, LoadingIcon } from "core/components/common/loading";
import SecurityService from "core/security/securityService";
import securityService from "core/security/securityService";
import {
  ID,
  ISECURABLE,
  PERMISSION,
  SECURABLE_TYPE,
} from "core/metamodel/metaConstant";
import SpecialConditionFilter from "core/grid/component/specialConditionFilter";
import { action, observable, ObservableMap } from "mobx";
import MdEntity, { LovItem } from "core/metamodel/mdEntity";
import { observer } from "mobx-react";
import VirtualList from "core/grid/component/virtualList";
import GridConfig from "core/grid/domain/gridConfig";
import { DomainAncestor } from "core/common/domain/DomainAncestor";
import { GridComposite, Movable } from "core/grid/gridUtils";
import { DATATYPE, DISPLAYTYPE } from "core/metamodel/mdField";
import {
  MultiUpdateDialog,
  MultiUpdateDialogReturnType,
} from "core/grid/component/multiUpdateDialog";
import {
  addSeparatorBetweenArrays,
  notEmpty,
} from "core/common/utils/arrayUtils";
import GenerateActivityDialog from "core/event/component/generateActivityDialog";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import uiService from "core/common/service/uiService";
import { buildURL, classNames } from "core/common/utils/domUtils";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/switchMap";
import { loc } from "core/common/config/locales";
import { MdHibernateEvent } from "core/metamodel/metaDomain";
import { PAGE } from "routes";
import { ChartGridWrapperComp } from "core/components/chart/chartComp";
import SuperFilterBar from "core/grid/component/superFilter";

import "core/grid/component/gridComp.less";
import "core/components/blockComp/activeItem.less";
import { removeItemFromLocalStorage } from "core/common/utils/storage";
import { grey400, grey500, grey700, pink500 } from "material-ui/styles/colors";
import debounce = require("lodash/debounce");
import last = require("lodash/last");
import get = require("lodash/get");
import MdCheckBoxOutlineBlank = require("react-icons/lib/md/check-box-outline-blank");
import MdCheckBox = require("react-icons/lib/md/check-box");
import MdRefresh = require("react-icons/lib/md/refresh");
import MdSync = require("react-icons/lib/md/sync");
import MdSyncDisabled = require("react-icons/lib/md/sync-disabled");
import MdCloudDownload = require("react-icons/lib/md/cloud-download");
import MdMenu = require("react-icons/lib/md/menu");
import SvgDone = require("react-icons/lib/md/done");
import SvgClear = require("react-icons/lib/md/clear");
import FaCopy = require("react-icons/lib/fa/copy");
import FaSearch = require("react-icons/lib/fa/search");
import FaBookmark = require("react-icons/lib/fa/bookmark");
import FaBookmarkO = require("react-icons/lib/fa/bookmark-o");
import MdChartPie = require("react-icons/lib/md/pie-chart.js");
import MdChartPieOutlined = require("react-icons/lib/md/pie-chart-outlined.js");
import FaEraser = require("react-icons/lib/fa/eraser");
import Route = ReactRouter.Route;
import { TextField } from "material-ui";
import gridService from "core/grid/gridService";
import {DOCUMENTFORMAT} from "core/document/documentDomain";
import { GridImportDialog } from './gridImportDialog';

const HEADER_ROW_HEIGHT = 28;

const GridComp__buttonStyle = {
  width: 32,
  height: 40,
  padding: "8px 4px",
  verticalAlign: "top",
};
const GridComp__iconStyle = { height: 18, width: 18 };
const GridComp__iconStyleSM = { height: 16, width: 16, color: grey400 };

const BUTTON_STYLE = { height: ROW_HEIGHT, width: 28, padding: 4 };
const ICON_STYLE = { fontSize: 13 };

export enum UILOCATION {
  page = "page",
  dialog = "dialog",
  main = "main",
  main_right = "main_right",
  tab = "tab",
  dashboard = "dashboard",
}

export enum BULKACTIONTYPE {
  ACTION = "ACTION",
}

export interface BulkAction {
  // type: 'ACTION', label: 'Download Invoices for printing', fn: this.downloadInvoices, that:this, securable: SECURABLE.downloadInvoices
  type: BULKACTIONTYPE;
  label: string;
  fn?: (grid: Grid) => any;
  that?: any;
  securable?: ISECURABLE;
}

export interface ExpandComponentProps {
  item: GridRow;
}

export interface MovableCompProps<T extends Movable> {
  grid: T;
}

type TFunctionMapFn = (cellId: ID, item?: GridRow, checked?: boolean) => any;

interface GridCompProps extends MovableCompProps<Grid> {
  uiLocation: UILOCATION;
  onGridChange?: Function;
  entities: ObservableMap<MdEntity>;
  gridClassName?: string;
  functionMap?: { [key: string]: TFunctionMapFn };
  multiSelect?: boolean;
  bodyStyle?: any;
  editForm?: React.ReactElement<FormProps<DomainAncestor, DomainAncestor>>;
  editFormName?: string;
  hideRefresh?: boolean;
  hideToolbar?: boolean;
  hideGridConfig?: boolean;
  hideCopyRow?: boolean;

  // root object na masteru (detailu) u editacniho gridu
  rootObject?: DomainAncestor;

  // funkce ktera se zavola pri etevreni editovatelneho radku, musi vracet promise
  // onEditFormLoad(rowObject) : Promise<RowObject>
  onEditFormLoad?: (rowObject: DomainAncestor) => Promise<DomainAncestor>;

  // pole popisnych objektu {label: textVMenu, fn: function(grid) } pro naplneni iconMenu Bulk Actions, fn se zavola
  bulkActions?: BulkAction[];

  // funkce, ktera pripravi paramObject pro formatRow call,
  // prepareFormatRowParamsFn(rootObject, rowObject)
  prepareFormatRowParamsFn?: Function;

  // pro clientGrid, kdy se pri editaci radku posila cely rootObject
  // editOverrideFn(rootObject, rowObject)
  editOverrideFn?: (
    rootObject: DomainAncestor,
    modifiedRows: GridRow[],
    toDeleteRows: GridRow[]
  ) => any | void;

  // funkce se zavola pri kopirovani rowObjectu pri kopirovani polozky editacniho gridu
  copyRowObjectFn?: Function;

  // if true rows are deletable
  showDelete?: boolean;

  // function (rowObject): bool  , to disable deleting on row per row basis. Makes sence only if showDelete is true
  disableDeleteFn?: Function;

  // if true rows are editable
  showEdit?: boolean;

  // if true, rows are expandable
  showExpand?: boolean;

  ExpandComponent?: React.ComponentClass<ExpandComponentProps>;

  // function (rowObject): bool  , to disable editing on row per row basis. Makes sence only if showEdit is true
  disableEditFn?: Function;

  deleteRowIcon?: string;

  // povoli na gridu multiUpdate pokud ma uzivatel toto SECURABLE
  multiUpdateSecurable?: ISECURABLE;

  // pro multi update editovanych gridu - save funkce
  multiUpdateSaveFn?: Function;

  // povoli na NE-EDITACNIM gridu multiDelete pokud ma uzivatel toto SECURABLE
  multiDeleteSecurable?: ISECURABLE;

  // pro multi delete ne-editovanych gridu - save funkce
  multiDeleteSaveFn?: (gridParams: GridParams) => Promise<any>;

  // pokud grid ma refreshOnData na vice entit;
  refreshEntities?: string[];
}

interface GridCompositeCompProps extends MovableCompProps<GridComposite> {
  uiLocation: UILOCATION;
  children?: React.ReactNode;
}

export const GridCompositeComp = observer(
  ({ grid, uiLocation, children }: GridCompositeCompProps) => (
    <div className={"row" + " md-grid--" + uiLocation}>{children}</div>
  )
);

type TStruct = { grid: Grid; page: number; rootObject: DomainAncestor };

const pagingSearchStream = new Subject<any>();
pagingSearchStream
  .mergeMap(
    (struct: TStruct) =>
      Promise.all([
        struct,
        struct.grid.search(struct.rootObject, false, struct.page, true),
      ]),
    null,
    2
  )
  .subscribe(
    action("subscribe-actionCb", ([struct, grid]: [TStruct, Grid]) => {
      console.log("pagingSearchStream resolved page %s", struct.page);
    })
  );

const dataRefreshSearchStream = new Subject<any>();
dataRefreshSearchStream
  .debounceTime(300)
  .switchMap((struct: TStruct) =>
    Observable.fromPromise(struct.grid.search(struct.rootObject, true, 1))
  )
  .subscribe(
    action("subscribe-actionCb", () => {
      console.log("dataRefreshSearchStream resolved");
    })
  );

@observer
export default class GridComp extends React.Component<
  GridCompProps,
  undefined
> {
  static contextTypes = {
    router: PropTypes.func.isRequired,
    muiTheme: PropTypes.object,
  };

  static defaultProps = {
    multiSelect: true,
    copyRowObjectFn: (x) => x,
  };

  private multiDeleteDialogRef: ConfirmationDialog;

  private onResizeDebounced: any;
  private horizontalScrollRegistered: boolean;
  private rowContainerRef: any;
  private virtualListRef: any;
  private gridHeaderRef: any;

  private headerPaddingRight = 0;
  private maxChartRows: number = 500;

  @observable showChart = false;
  @observable showExceedChartRows = false;
  @observable selectedForChart: number = this.maxChartRows;
  @observable loadingNewRowsIds = false;

  private dataChangeEventSource: EventSource;

  constructor(props) {
    super(props);

    console.debug("GridComp#constructor, props: %o", props);
  }

  componentWillMount() {
    this.onResizeDebounced = debounce(this.onResize, 100);
  }

  componentWillReceiveProps(nextProps: GridCompProps) {
    console.log(
      "componentWillReceiveProps: old searchTerm = %s, new searchTerm = %s",
      this.props.grid.searchTerm,
      nextProps.grid.searchTerm
    );
  }

  componentDidMount() {
    console.debug(
      "gridComp %s componentDidMount: rowContainer = %O",
      this.props.grid.gridLocation,
      this.rowContainerRef
    );

    window.addEventListener("resize", this.onResizeDebounced);

    this.createDataChangeEventSource();
  }

  componentDidUpdate(prevProps) {
    if (
      this.rowContainerRef &&
      !this.horizontalScrollRegistered &&
      !this.usesVirtualScrolling(this.props.grid)
    ) {
      this.rowContainerRef.addEventListener("scroll", this.onScrollGrid);
      this.horizontalScrollRegistered = true;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResizeDebounced);
    if (this.rowContainerRef) {
      this.rowContainerRef.removeEventListener("scroll", this.onScrollGrid);
    }
    this.destroyDataChangeEventSource();
  }

  createDataChangeEventSource = () => {
    let { grid, rootObject, refreshEntities } = this.props;
    if (grid.refreshData) {
      console.log("Creating event source");
      let entityNames =
        refreshEntities && refreshEntities.length
          ? refreshEntities
          : [grid.$gridLocationRef.entityName];
      this.dataChangeEventSource = new EventSource(
        buildURL("/api/core/meta/entity-change", { entityName: entityNames })
      );
      this.dataChangeEventSource.onmessage = (e) => {
        console.log("%c SSE MESSAGE: %o", "background-color: blue", e);
        let mdhEvent: MdHibernateEvent = JSON.parse(e.data);
        if (
          entityNames.includes(mdhEvent.entityName) &&
          (!grid.isEditable() || !grid.$dirty)
        ) {
          dataRefreshSearchStream.next({ grid, page: 1, rootObject });
        }
      };
      this.dataChangeEventSource.onerror = (e) => {
        console.log("%c SSE ERROR: %o", "background-color: red", e);
        if (this.dataChangeEventSource.readyState == 2) {
          setTimeout(this.createDataChangeEventSource, 5000);
        }
      };
      this.dataChangeEventSource.onopen = (e) => {
        console.log("%c SSE OPEN: %o", "background-color: green", e);
      };
    }
  };

  destroyDataChangeEventSource() {
    if (this.dataChangeEventSource) {
      console.debug("Destroing event source");
      this.dataChangeEventSource.close();
    }
  }

  rowContainerRefHandler = (comp) => {
    this.rowContainerRef = comp;
  };

  virtualListRefHandler = (comp) => {
    this.virtualListRef = comp;
  };

  gridHeaderRefHandler = (comp) => {
    this.gridHeaderRef = comp;
  };

  /* *******   PRIVATE METHODS ************ */

  @action search = (scrollToTop?: boolean) => {
    return this.props.grid.search(this.props.rootObject)
      .then(action("gridComp-search-callback", () => {
        if (scrollToTop && this.virtualListRef) {
          this.virtualListRef.scrollTop();
        }
      })
    );
  };

  @action pagingSearch = (page: number): any => {
    let { grid, rootObject } = this.props;
    if (!grid.data.requestedPages.has(page)) {
      grid.data.requestedPages.add(page);
      pagingSearchStream.next({ grid, page, rootObject });
    }
  };

  _computeNewHPR() {
    let _cont = this.rowContainerRef;
    if (!_cont) return null;
    return _cont.scrollHeight > _cont.clientHeight ? 15 : 0;
  }

  chartCanBeShown(): boolean {
    let { grid } = this.props;
    if (grid == null) {
      return false;
    }
    if (
      grid.getTotalCount() == "null" ||
      grid.getTotalCount() == "undefined" ||
      (grid.getTotalCount() > this.maxChartRows && grid.selectedAllRows)
    ) {
      return false;
    }
    return (
      grid.getTotalCount() <= this.maxChartRows ||
      (grid.selectedRowIds.size > 0 &&
        grid.selectedRowIds.size <= this.maxChartRows)
    );
  }

  @action onResize = () => {
    let newHPR = this._computeNewHPR();
    if (newHPR !== null && this.headerPaddingRight !== newHPR) {
      this.headerPaddingRight = newHPR;
      this.forceUpdate();
    }
  };

  @action onScrollGrid = () => {
    // v pripade ze je header, posuneme ho do spravne pozice
    if (this.gridHeaderRef) {
      this.gridHeaderRef.style.left = -this.rowContainerRef.scrollLeft + "px";
    }
  };

  /* *******   EVENT HENDLERS ************ */

  @action onSelectGridConfig = (event, gc) => {
    console.log("onSelectGridConfig gridId = " + gc.gridId);

    let grid = this.props.grid;
    grid.assignActiveGridConfig(gc);
    grid.searchTerm = "";
    grid.conditionArray = null;
    grid.data = null;

    if (this.props.onGridChange) {
      this.props.onGridChange(grid);
    }

    if (!(grid.activeGridConfig && !grid.activeGridConfig.refreshOnPage)) {
      this.search(true);
    }
    if (this.showExceedChartRows) this.showExceedChartRows = false;
  };

  @action onSetDefault = (event, gridConfig: GridConfig) => {
    console.log("onSetDefault %O", gridConfig);

    let { grid } = this.props;

    GridService.setDefault(gridConfig.gridId, gridConfig.gridLocation).then((response) => {
      for (let gc of grid.gridConfigs) {
        gc.defaultGrid = undefined;
      }
      gridConfig.defaultGrid = true;
      removeItemFromLocalStorage(
        "GridLocation",
        loc.lang,
        gridConfig.gridLocation
      );
    });
  };

  @action onSelectGridManage = (eventKey, event) => {
    if (!event) event = eventKey; // protoze jednou je to volane tak a jednou tak
    event.preventDefault();
    let grid = this.props.grid;

    let params = {
      gridLocation: grid.gridLocation,
      gridId: grid.activeGridConfig ? grid.activeGridConfig.gridId : undefined,
    };

    this.context.router.transitionTo("gridAdmin", params);
  };

  @action onSearchTermChange = (evt) => {
    let grid = this.props.grid;
    grid.searchTerm = evt.target.value || "";
  };

  @action onSearchTermSubmit = (evt) => {
    evt.preventDefault();
    let grid = this.props.grid;
    console.log("onSearchTermSubmit: %s", grid.searchTerm);

    if (this.props.onGridChange) {
      this.props.onGridChange(grid);
    }

    this.search(true);
  };

  @action onClickColumnSort = (sortObject) => {
    console.log("onClickColumnSort %o", sortObject);

    let grid = this.props.grid;
    grid.sortArray = [sortObject];

    if (this.props.onGridChange) {
      this.props.onGridChange(grid);
    }

    this.search(true);
  };

  @action changeAndSearch = () => {
    console.log("changeAndSearch");
    if (this.props.onGridChange) {
      this.props.onGridChange(this.props.grid);
    }
    this.search(true);
  };

  @action onShowSelection = (evt) => {
    console.log("onShowSelection %O", evt);
    let grid = this.props.grid;

    grid.selectedRowIds = new Set();
    grid.deselectedRowIds = new Set();
    grid.selectedAllRows = false;
    grid.showSelection = !grid.showSelection;

    if (this.virtualListRef) {
      this.virtualListRef.forceUpdate();
    }
  };

  @action selectFirstRows = (e, onSelected: () => void) => {
    const { grid } = this.props;
    if(grid.selectedAllRows) grid.selectedAllRows = false;
    if (!grid.showSelection) this.onShowSelection(e);
    grid.selectedRowIds = new Set<ID>();

    let rowIds: ID[] = grid.data.rowIds();
    if (rowIds.length < this.selectedForChart) {
      //next row ids need to be fetched
      this.loadingNewRowsIds = true;
      gridService
        .getRowIds(grid, this.selectedForChart)
        .then((fetchedIds: number[]) => {
          this.fillSelectedRowIds(fetchedIds, grid, this.selectedForChart);
          if (this.virtualListRef) this.virtualListRef.forceUpdate();
          this.loadingNewRowsIds = false;
          onSelected();
        });
    } else {
      this.fillSelectedRowIds(rowIds, grid, this.selectedForChart);
      if (this.virtualListRef) this.virtualListRef.forceUpdate();
      onSelected();
    }
  };

  private fillSelectedRowIds(rowIds: ID[], grid: Grid, selectedCount: number) {
    for (let i = 0; i < selectedCount; i++) {
      grid.selectedRowIds.add(rowIds[i]);
    }
  }

  @action onCheckCbxAll = (e) => {
    let grid = this.props.grid;

    grid.selectedAllRows = !grid.selectedAllRows;

    if (grid.selectedAllRows) {
      grid.selectedRowIds = new Set(grid.data.rowIds());
      grid.deselectedRowIds = new Set();
    } else {
      grid.selectedRowIds = new Set();
      grid.deselectedRowIds = new Set();
    }

    if (this.virtualListRef) this.virtualListRef.forceUpdate();
  };

  @action onClickRow = (clickedRowId, e) => {
    let grid = this.props.grid;
    console.debug("processRowSelection: %o", clickedRowId);
    // provedeme pouze pokud je zapnuto oznacovani radku
    if (grid.showSelection) {
      // odstranime vsechny oznaceni
      window.getSelection().removeAllRanges();
      // zkopirujeme si mapu oznacenych radku
      let lastSelected = grid.lastClickedRow;
      let clonedSet = new Set(grid.selectedRowIds);

      if (clonedSet.has(clickedRowId)) {
        // pokud jsme klikli na oznaceny radek, odebereme ho z oznaceni
        clonedSet.delete(clickedRowId);
        if (grid.selectedAllRows) grid.deselectedRowIds.add(clickedRowId);
      } else {
        // pokud jsme klikli na neoznaceny radek, pridame ho do oznaceni
        clonedSet.add(clickedRowId);
        if (grid.selectedAllRows) grid.deselectedRowIds.delete(clickedRowId);
      }

      // pokud byl pri kliknuti drzen shift a zaroven existoval klik predtim
      // a zaroven se nekliklo na jeden a ten samy radek
      if (e.shiftKey && lastSelected && lastSelected !== clickedRowId) {
        let startStop = false;
        // Projedeme vsechny radky
        this.props.grid.data.flatRows().every((row) => {
          // pokud jsme nasli zacatek nebo konec oznaceni
          if (row.rowId === clickedRowId || row.rowId === lastSelected) {
            // pokud jsme narazili na zacatek oznaceni - nastavime startStop na true
            // zastaveni cylku pokud jsme na konci oznaceni (startStop == false)
            return (startStop = !startStop);
          } else if (startStop) {
            // pokud jsme uprostred oznaceneho bloku - invertujeme oznaceni radku
            if (clonedSet.has(row.rowId)) {
              clonedSet.delete(row.rowId);
              if (grid.selectedAllRows) grid.deselectedRowIds.add(clickedRowId);
            } else {
              clonedSet.add(row.rowId);
              if (grid.selectedAllRows)
                grid.deselectedRowIds.delete(clickedRowId);
            }
          }
          // true, aby cyklus pokracoval dal
          return true;
        });
      }
      grid.selectedRowIds = clonedSet;
      grid.lastClickedRow = clickedRowId;
    }

    if (this.virtualListRef) {
      this.virtualListRef.forceUpdate();
    }
  };

  @action onClickRefresh = (evt) => {
    let { grid } = this.props;
    console.log("onClickRefresh %o", evt);
    this.search()
      .then((x) => {
        if (grid.isEditable()) {
          grid.deletedRowIds = new Set();
          grid.$dirty = false;
        }
      })
  };

  @action onClickClearAndRefresh = (evt) => {
    let { grid } = this.props;
    grid.searchTerm = "";
    grid.conditionArray = [];
    grid.initSuperFilter();
    grid.resetSpecialConditions(grid.activeGridConfig);

    if (this.props.onGridChange) {
      this.props.onGridChange(grid);
    }

    this.onClickRefresh(evt);
  };

  @action onClickSync = (evt) => {
    this.props.grid.refreshData = !this.props.grid.refreshData;

    if (this.props.grid.refreshData) {
      this.createDataChangeEventSource();
    } else {
      this.destroyDataChangeEventSource();
    }
  };

  @action onEditRow = (item: GridRow) => {
    let { grid, onEditFormLoad, editFormName, rootObject } = this.props;

    console.log("onEditRow %O", item);

    let rowObject: DomainAncestor = item.rowObject;
    let form = rowObject.getForm(editFormName);

    let onEditFormLoadPromise: Promise<DomainAncestor> = onEditFormLoad
      ? onEditFormLoad(rowObject)
      : Promise.resolve(rowObject);

    onEditFormLoadPromise.then((x) => {
      form.$open = true;
      form.$pristineObject = rowObject.cloneDeep();
      rootObject.$dirty = true;
      grid.$dirty = true;

      if (this.virtualListRef) this.virtualListRef.forceUpdate();
    });
  };

  @action onExpandRow = (rowId: ID) => {
    let { grid, onEditFormLoad, editFormName, rootObject } = this.props;

    console.log("onExpandRow %s %s", rowId);

    let item: GridRow = grid.findRow(rowId);
    item.expanded = !item.expanded ? (item.rowObject ? 2 : 1) : 0;

    if (this.virtualListRef) this.virtualListRef.forceUpdate();
  };

  @action onExpandAllRows = () => {
    let { grid, onEditFormLoad, editFormName, rootObject } = this.props;

    console.log("onExpandAllRows");

    grid.expandAllRows = !grid.expandAllRows;

    for (let item of grid.data.flatRows()) {
      item.expanded = grid.expandAllRows
        ? !item.expanded
          ? item.rowObject
            ? 2
            : 1
          : item.expanded
        : 0;
    }

    if (this.virtualListRef) this.virtualListRef.forceUpdate();
  };

  @action onClickChart = () => {
    if (this.showChart == false) {
      if (this.chartCanBeShown()) {
        this.showChart = true;
      } else {
        this.showExceedChartRows = !this.showExceedChartRows;
        if (this.showExceedChartRows) this.selectedForChart = this.maxChartRows;
      }
    } else {
      this.showChart = false;
    }
  };

  /**
   * arraySpec = [{item, index, toDelete: true}, ....]
   * @param arraySpec
   */
  @action onDeleteRow = (rows: GridRow[]) => {
    let { grid, rootObject } = this.props;

    console.log("onDeleteRow rows = %O", rows);

    if (!rows.length) return;

    let rowIds = rows
      .filter((row) => !row.rowObject.$added)
      .map((row) => row.rowId);

    if (this.props.editOverrideFn) {
      grid.addDeletedId(rowIds);
      this.props.editOverrideFn(rootObject, null, rows).then(() => {
        if (this.virtualListRef) this.virtualListRef.forceUpdate();
      });
    } else {
      grid.addDeletedId(rowIds);

      grid.data.deleteRows(rows);

      grid.data.totalCount = grid.data.totalCount - rows.length;

      if (rows.length > 0) {
        grid.$dirty = true;
        rootObject.$dirty = true;
      }

      if (this.virtualListRef) this.virtualListRef.forceUpdate();
    }
  };

  onDismissAlert = () => {
    let { grid } = this.props;
    grid.errors = null;
  };

  bulkDelete = (grid: Grid) => {
    let selectedCount = grid.getSelectedCount();
    console.log("Deleteting count: %s", selectedCount);
    if (!selectedCount) return;

    if (this.props.multiDeleteSaveFn) {
      return new Promise((resolve, reject) => {
        this.multiDeleteDialogRef.open(
          resolve,
          reject,
          "Do you really want to delete " +
            selectedCount +
            " " +
            grid.$gridLocationRef.$entityRef.label +
            " ?"
        );
      })
        .then(() => {
          uiService.showToolbarActionFlag();
          return this.props.multiDeleteSaveFn(grid.createFullParams());
        })
        .then(() => {
          uiService.hideToolbarActionFlag();
          return this.search();
        })
        .catch((e) => {});
    } else {
      return this.onDeleteRow(grid.getSelectedRows());
    }
  };

  private multiUpdateDialogRef: MultiUpdateDialog;
  multiUpdateDialogRefHandler = (comp) => {
    this.multiUpdateDialogRef = comp;
  };

  private gridImportDialogRef: GridImportDialog;
  gridImportDialogRefHandler = (comp) => {
    this.gridImportDialogRef = comp;
  };


  bulkUpdate = (grid: Grid) => {
    if (!grid.data) return;

    return new Promise((resolve, reject) => {
      this.multiUpdateDialogRef.open(
        resolve,
        reject,
        grid,
        this.props.editFormName,
        this.props.rootObject
      );
      //this.forceUpdate();
      this.multiUpdateDialogRef.forceUpdate();
    })
      .then((res: MultiUpdateDialogReturnType) => {
        if (res.saveRequired) {
          return this.props.multiUpdateSaveFn(null);
        } else {
          this.search();
        }
      })
      .catch((e) => {});
  };

  private generateActivityDialogRef: GenerateActivityDialog;
  generateActivityDialogRefHandler = (comp) => {
    this.generateActivityDialogRef = comp;
  };

  onGenerateActivity = (aclov: LovItem) => {
    let { grid } = this.props;
    console.log("activityConfig: ", aclov);
    if (!grid.data) return;

    return new Promise((resolve, reject) => {
      this.generateActivityDialogRef.open(resolve, reject, grid, aclov);
      this.generateActivityDialogRef.forceUpdate();
    }).catch((e) => {});
  };
  multiDeleteDialogRefHandler = (comp) => (this.multiDeleteDialogRef = comp);


  bulkImport = (grid: Grid) => {

    return new Promise((resolve, reject) => {
      this.gridImportDialogRef.open(
        resolve,
        reject,
        grid
      );
      this.gridImportDialogRef.forceUpdate();
    })
      .catch((e) => {});

  };



  usesVirtualScrolling = (grid: Grid) =>
    grid.data &&
    grid.data.totalCount >
      (grid.activeGridConfig ? grid.activeGridConfig.gridScrollSize : 50);

  render() {
    let {
      grid,
      children,
      uiLocation,
      gridClassName,
      multiSelect,
      bodyStyle,
      hideToolbar,
      hideRefresh,
      hideGridConfig,
      showEdit,
      showDelete,
      showExpand,
      entities,
      bulkActions,
      multiUpdateSecurable,
      onGridChange,
      multiDeleteSaveFn,
      multiDeleteSecurable,
    } = this.props;

    console.debug(
      "gridComp %s rendering: dataCount = %s, deleted = %O, searchTerm = %s",
      grid.gridLocation,
      grid.getTotalCount(),
      grid.deletedRowIds,
      grid.searchTerm
    );

    let dropdownId = grid.gridLocation + "_dropdown";

    const gridClassNames = classNames(
      "md-grid",
      "md-grid--" + uiLocation,
      gridClassName
    );

    this.headerPaddingRight = this._computeNewHPR();

    let canEditGrid = true;
    if (grid.$gridLocationRef.gridType === GRIDTYPE.SQLQUERY) {
      let securableId = lovValue(grid.$gridLocationRef.securable);
      let permissionList = securityService.permissionList(securableId);
      canEditGrid = permissionList && permissionList.length >= 2;
    }

    if (!grid.activeGridConfig && canEditGrid) {
      return (
        <div className={gridClassNames}>
          <Navbar
            fluid
            style={{ marginBottom: 10, minHeight: "initial", fontSize: 14 }}
          >
            <Nav>
              <NavItem
                eventKey={3}
                href={this.context.router.makeHref(
                  "gridAdmin",
                  { gridLocation: grid.gridLocation },
                  addTenantToQuery()
                )}
                onClick={this.onSelectGridManage}
              >{loc.i18n`Create Grid`}</NavItem>
            </Nav>
          </Navbar>
        </div>
      );
    }

    let gridConfigMenu = (
      <NavDropdown
        id={dropdownId}
        eventKey={3}
        title={grid.activeGridConfig.label}
        disabled={this.showChart}
      >
        {grid.gridConfigs.map((gc, index) => {
          let routeName = last<Route>(this.context.router.getCurrentRoutes())
            .name;
          let routeDef =
            uiLocation === UILOCATION.page
              ? this.context.router.makeHref(
                  routeName,
                  Object.assign({}, this.context.router.getCurrentParams(), {
                    gridId: gc.gridId,
                  }),
                  addTenantToQuery()
                )
              : "";

          return (
            <GridSelectMenuItem
              key={gc.gridId}
              onSelect={this.onSelectGridConfig}
              onSetDefault={this.onSetDefault}
              route={routeDef}
              gc={gc}
            />
          );
        })}

        {canEditGrid ? <MenuItem divider /> : null}
        {canEditGrid ? (
          <MenuItem
            href={this.context.router.makeHref(
              "gridAdmin",
              {
                gridLocation: grid.gridLocation,
                gridId: grid.activeGridConfig.gridId,
              },
              addTenantToQuery()
            )}
            onSelect={this.onSelectGridManage}
          >
            {" "}
            {loc.i18n`Manage`}{" "}
          </MenuItem>
        ) : null}
      </NavDropdown>
    );

    let columnWidths = grid.activeGridWidths;

    let muiMenuItemStyle = { fontSize: 14, lineHeight: "40px" };

    let exportActionsEnabled = grid.isSelectedRows();

    let builtinExportActions = [
      { label: "Excel", format: DOCUMENTFORMAT.XLS },
      { label: "Excel 2007", format: DOCUMENTFORMAT.XLSX },
      { label: "CSV", format: DOCUMENTFORMAT.CSV },
      { label: "XML Grid", format: DOCUMENTFORMAT.XML },
      { label: "XML Object", format: DOCUMENTFORMAT.XML_OBJECT },
    ];

    // if (uiLocation === 'main' || uiLocation === 'tab') {
    //   if (grid.data && grid.data.rows && grid.data.rows.length && grid.data.rows.length <= 600) {
    //     if (!bodyStyle) bodyStyle = {};
    //     bodyStyle.minHeight = ROW_HEIGHT * (grid.data.rows.length + 2) + 8;
    //   }
    // }

    const usesVirtualScrolling = this.usesVirtualScrolling(grid);
    const dataContainerDivStyle = {
      marginBottom: 20,
      minHeight: grid.isEditable() ? 400 : null,
    };

    let scrollContainer = this.rowContainerRef;
    if (
      uiLocation === UILOCATION.main ||
      uiLocation === UILOCATION.tab ||
      uiLocation === UILOCATION.main_right
    ) {
      if (usesVirtualScrolling) {
        scrollContainer = window;
      }
    }

    let localBulkActions: BulkAction[] = bulkActions ? bulkActions.slice() : [];

    if (multiUpdateSecurable) {
      localBulkActions.push({
        type: BULKACTIONTYPE.ACTION,
        label: loc.i18n`Update rows`,
        fn: this.bulkUpdate,
        that: this,
        securable: multiUpdateSecurable,
      });
    }
    if (showDelete || (multiDeleteSaveFn && multiDeleteSecurable)) {
      localBulkActions.push({
        type: BULKACTIONTYPE.ACTION,
        label: loc.i18n`Delete rows`,
        fn: this.bulkDelete,
        that: this,
        securable: multiDeleteSecurable,
      });
    }

    localBulkActions = localBulkActions.filter(
      (action) =>
        !action.securable ||
        SecurityService.hasRight(
          action.securable.name,
          action.securable.permission ? action.securable.permission : PERMISSION.Execute
        )
    );
    if (grid.$gridLocationRef.importConfigs?.length) {
      localBulkActions.push({
        type: BULKACTIONTYPE.ACTION,
        label: loc.i18n`Import records`,
        fn: this.bulkImport,
        that: this,
      });
    }

    const Navbar_style = {
      marginBottom: 10,
      minHeight: "initial",
      fontSize: 14,
    };
    const MdGridHeaderWrapper_style = { paddingRight: this.headerPaddingRight };
    if (uiLocation === UILOCATION.main_right || uiLocation === UILOCATION.tab) {
      Object.assign(Navbar_style, { position: "sticky", top: 40, zIndex: 2 });
      Object.assign(MdGridHeaderWrapper_style, {
        position: "sticky",
        top: 80,
        backgroundColor: "white",
        zIndex: 2,
      });
    }

    const isSQLQueryGrid: boolean =
      grid.$gridLocationRef.gridType === GRIDTYPE.SQLQUERY;
    return (
      <div className={gridClassNames}>
        {multiDeleteSaveFn && multiDeleteSecurable ? (
          <ConfirmationDialog
            ref={this.multiDeleteDialogRefHandler}
            cancelButtonText={loc.i18n`Cancel`}
            okButtonText="OK"
          />
        ) : null}

        {hideToolbar ? (
          ""
        ) : (
          <Navbar fluid style={Navbar_style}>
            {!hideGridConfig ? <Nav navbar>{gridConfigMenu}</Nav> : null}

            {multiSelect && !isSQLQueryGrid ? (
              <MdIconButton
                onClick={this.onShowSelection}
                style={GridComp__buttonStyle}
                iconStyle={GridComp__iconStyle}
                disabled={this.showChart}
              >
                {grid.showSelection ? (
                  <MdCheckBox />
                ) : (
                  <MdCheckBoxOutlineBlank />
                )}
              </MdIconButton>
            ) : null}

            {grid.$dirty || grid.clientGrid || hideRefresh ? null : (
              <MdIconButton
                onClick={this.onClickRefresh}
                style={GridComp__buttonStyle}
                iconStyle={GridComp__iconStyle}
                disabled={this.showChart}
              >
                <MdRefresh />
              </MdIconButton>
            )}

            <ZzIconButtonMenu
              disabled={!exportActionsEnabled || this.showChart}
              buttonIcon={<MdCloudDownload />}
              style={{ verticalAlign: "top" }}
              iconStyle={GridComp__iconStyle}
            >
              {builtinExportActions.map((action, index) => (
                <MuiMenuItem
                  key={index + 10}
                  style={muiMenuItemStyle}
                  innerDivStyle={{ padding: 0 }}
                >
                  <div className="mui-menu-item">
                    <a
                      href={GridService.exportUrl(grid, action.format, true)}
                      className="mui-menu-item-link-1"
                      target="_blank"
                    >
                      {action.label}
                    </a>
                    <a href={GridService.exportUrl(grid, action.format, false)}>
                      <FileFileDownload
                        style={{ verticalAlign: "middle" }}
                        color={grey500}
                      />
                    </a>
                  </div>
                </MuiMenuItem>
              ))}

              {grid.$gridLocationRef.assignedDocumentTypes
                ? grid.$gridLocationRef.assignedDocumentTypes.map(
                    (linkObj, index) => (
                      <MuiMenuItem
                        key={index}
                        style={muiMenuItemStyle}
                        innerDivStyle={{ padding: 0 }}
                      >
                        <div className="mui-menu-item">
                          <a
                            href={GridService.documentExportUrl(
                              grid,
                              linkObj.value,
                              true
                            )}
                            className="mui-menu-item-link-1"
                            target="_blank"
                          >
                            {linkObj.label}
                          </a>
                          <a
                            href={GridService.documentExportUrl(
                              grid,
                              linkObj.value,
                              false
                            )}
                          >
                            <FileFileDownload
                              style={{ verticalAlign: "middle" }}
                              color={grey500}
                            />
                          </a>
                        </div>
                      </MuiMenuItem>
                    )
                  )
                : null}
            </ZzIconButtonMenu>

            <SpecialConditionFilter
              grid={grid}
              search={this.search}
              onGridChange={onGridChange}
              disabled={this.showChart}
            />

            {grid.$gridLocationRef.enableRefreshOnData ? (
              <MdIconButton
                onClick={this.onClickSync}
                style={{
                  width: 28,
                  height: 40,
                  padding: "8px 2px",
                  verticalAlign: "top",
                }}
                iconStyle={GridComp__iconStyle}
              >
                {grid.refreshData ? <MdSync /> : <MdSyncDisabled />}
              </MdIconButton>
            ) : null}

            {notEmpty(localBulkActions) ||
            notEmpty(grid.$gridLocationRef.assignedActivityConfigs) ? (
              <ZzIconButtonMenu
                disabled={!exportActionsEnabled || this.showChart}
                buttonIcon={<MdMenu />}
                style={{ verticalAlign: "top" }}
                iconStyle={GridComp__iconStyle}
              >
                {addSeparatorBetweenArrays(
                  <MuiDivider />,
                  localBulkActions.map((action, index) => (
                    <MuiMenuItem
                      key={index}
                      primaryText={action.label}
                      style={muiMenuItemStyle}
                      onClick={action.fn.bind(action.that, grid)}
                    />
                  )),
                  grid.$gridLocationRef.assignedActivityConfigs.map(
                    (activityConfig, index) => (
                      <MuiMenuItem
                        key={index}
                        primaryText={activityConfig.label}
                        style={muiMenuItemStyle}
                        onClick={this.onGenerateActivity.bind(
                          this,
                          activityConfig
                        )}
                      />
                    )
                  )
                )}
              </ZzIconButtonMenu>
            ) : null}
            <ChartIconOverlay
              grid={grid}
              showExceedChartRows={this.showExceedChartRows}
              onShowExceedChartRowsChange={(show: boolean) =>
                (this.showExceedChartRows = show)
              }
              onClickChart={this.onClickChart}
              showChart={this.showChart}
              loadingNewRowsIds={this.loadingNewRowsIds}
              maxChartRows={this.maxChartRows}
              selectFirstRows={this.selectFirstRows}
              selectedForChart={this.selectedForChart}
              onSelectedForChartChange={(value: number) =>
                (this.selectedForChart = value)
              }
            />
            <div
              style={{
                display: "inline-block",
                lineHeight: "40px",
                verticalAlign: "top",
              }}
              className={classNames({
                "color-red-500": grid.data && grid.data.truncated,
              })}
            >
              {" "}
              {grid.data && grid.data.totalCount
                ? grid.data.totalCount +
                  loc.i18n` rows` +
                  (grid.data.truncated ? " (truncated)" : "")
                : ""}{" "}
            </div>

            {children}
            <form
              className="navbar-form navbar-right"
              role="search"
              onSubmit={this.onSearchTermSubmit}
            >
              <MdIconButton
                onClick={this.onClickClearAndRefresh}
                style={{
                  width: 32,
                  height: 40,
                  padding: "6px 4px 10px 4px",
                  verticalAlign: "top",
                }}
                iconStyle={GridComp__iconStyleSM}
              >
                <FaEraser />
              </MdIconButton>

              <FieldGroup
                type="text"
                placeholder={loc.i18n`Search`}
                onChange={this.onSearchTermChange}
                value={grid.searchTerm}
                bsSize="small"
              />

              <OverlayTrigger
                placement="left"
                overlay={
                  <Tooltip
                    id="searchTooltip"
                    style={{ fontSize: 13 }}
                    className="left-aligned-tooltip"
                  >
                    {grid.activeGridConfig.searchLabel.map((text, i) => (
                      <span key={i}>
                        {text}
                        <br />
                      </span>
                    ))}
                  </Tooltip>
                }
              >
                <FaSearch
                  onClick={this.onSearchTermSubmit}
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 15,
                    color: grey400,
                  }}
                />
              </OverlayTrigger>
            </form>
          </Navbar>
        )}

        {grid.errors ? (
          <ErrorComp messages={grid.errors} onDismiss={this.onDismissAlert} />
        ) : null}

        {grid.activeGridConfig.getSuperFilters().length ? (
          <SuperFilterBar
            grid={grid}
            gridConfig={grid.activeGridConfig}
            refreshGrid={this.changeAndSearch}
          />
        ) : null}

        {!this.showChart && (
          <div
            className="md-grid-header-wrapper"
            style={MdGridHeaderWrapper_style}
          >
            <div className="md-grid-header" ref={this.gridHeaderRefHandler}>
              {grid.showSelection ? (
                <div
                  className="md-grid-header-cell"
                  style={{ float: "left", minWidth: "28px", width: "28px" }}
                >
                  <MdCheckbox
                    name="selectAllCheckbox"
                    onCheck={this.onCheckCbxAll}
                    checked={grid.selectedAllRows}
                  />
                </div>
              ) : null}
              {showEdit ? (
                <div
                  className="md-grid-header-cell"
                  style={{
                    float: "left",
                    minWidth: 20,
                    height: HEADER_ROW_HEIGHT,
                    width: 20,
                    textAlign: "center",
                  }}
                >
                  E
                </div>
              ) : null}
              {showDelete ? (
                grid.deletedRowIds && grid.deletedRowIds.size ? (
                  <Badge
                    badgeContent={grid.deletedRowIds.size}
                    primary={true}
                    badgeStyle={{ fontSize: 8, width: 12, height: 12 }}
                    style={{ float: "left", padding: "0 8px 0 0" }}
                  >
                    <div
                      className="md-grid-header-cell"
                      style={{
                        float: "left",
                        minWidth: 24,
                        height: HEADER_ROW_HEIGHT,
                        width: 24,
                        textAlign: "center",
                      }}
                    >
                      D
                    </div>
                  </Badge>
                ) : (
                  <div
                    className="md-grid-header-cell"
                    style={{
                      float: "left",
                      minWidth: 24,
                      height: HEADER_ROW_HEIGHT,
                      width: 24,
                      textAlign: "center",
                    }}
                  >
                    D
                  </div>
                )
              ) : null}
              {showExpand ? (
                <div
                  className="md-grid-header-cell"
                  style={{
                    float: "left",
                    minWidth: 20,
                    height: HEADER_ROW_HEIGHT,
                    width: 20,
                    textAlign: "center",
                  }}
                >
                  <IconButton
                    onClick={this.onExpandAllRows}
                    style={{
                      height: HEADER_ROW_HEIGHT,
                      width: 20,
                      padding: "4px 0",
                    }}
                    iconStyle={{ fontSize: 13, color: grey700 }}
                  >
                    {grid.expandAllRows ? (
                      <FontIcon className="fa fa-caret-down" />
                    ) : (
                      <FontIcon className="fa fa-caret-right" />
                    )}
                  </IconButton>{" "}
                  : null
                </div>
              ) : null}

              <div
                className="md-grid-data-row"
                style={{
                  marginRight:
                    (grid.showSelection ? 28 : 0) +
                    (showEdit ? 20 : 0) +
                    (showDelete ? 24 : 0) +
                    (showExpand ? 24 : 0),
                }}
              >
                {grid.activeGridConfig.columns.map((gcCol, columnIndex) => {
                  if (!gcCol.field) return <div />;

                  let sortObject = grid.sortArray
                    ? grid.sortArray.find(
                        (so) => so.field.fieldName === gcCol.field.fieldName
                      )
                    : null;
                  let conditionObject = grid.conditionArray
                    ? grid.conditionArray.find(
                        (gcc) => gcc.columnName === gcCol.field.fieldName
                      )
                    : null;

                  let styleObject = {
                    width: columnWidths[0][columnIndex] + "%",
                    minWidth: columnWidths[1][columnIndex] + "px",
                    maxWidth: columnWidths[2][columnIndex] + "px",
                    textAlign: gcCol.field.textAlign
                      ? gcCol.field.textAlign
                      : undefined,
                  };

                  return (
                    <div
                      key={columnIndex}
                      className="md-grid-header-cell"
                      style={styleObject}
                    >
                      <GridHeader
                        gridConfigField={gcCol}
                        field={gcCol.field}
                        sortObject={sortObject}
                        conditionObject={conditionObject}
                        grid={grid}
                        entities={entities}
                        gridConfig={grid.activeGridConfig}
                        onClickLink={this.onClickColumnSort}
                        refreshGrid={this.changeAndSearch}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <div
          ref={this.rowContainerRefHandler}
          className="md-grid-body"
          style={bodyStyle}
        >
          {grid.loading ? <LoadingElement /> : null}
          {this.showChart ? (
            <ChartGridWrapperComp grid={grid} />
          ) : grid.data ? (
            grid.data.totalCount === 0 ? (
              loc.get("core.grid.no-data")
            ) : usesVirtualScrolling ? (
              <div style={dataContainerDivStyle}>
                <VirtualList
                  ref={this.virtualListRefHandler}
                  gridData={grid.data}
                  renderItem={this.renderItem}
                  container={scrollContainer}
                  header={this.gridHeaderRef}
                  search={this.pagingSearch}
                />
                {grid.data.aggregateRows.map((item, index) =>
                  this.renderItem(item, -index - 1)
                )}
              </div>
            ) : (
              <div style={dataContainerDivStyle}>
                {grid.data.flatRows().map(this.renderItem)}
                {grid.data.aggregateRows.map((item, index) =>
                  this.renderItem(item, -index - 1)
                )}
              </div>
            )
          ) : null}
        </div>

        {multiUpdateSecurable && (
          <MultiUpdateDialog ref={this.multiUpdateDialogRefHandler} />
        )}
        {notEmpty(grid.$gridLocationRef.assignedActivityConfigs) && (
          <GenerateActivityDialog ref={this.generateActivityDialogRefHandler} />
        )}
        {!!grid.$gridLocationRef.importConfigs?.length && (
          <GridImportDialog ref={this.gridImportDialogRefHandler} />
        )}

      </div>
    );
  }

  renderItem = (item: GridRow, index: number) => {
    let {
      grid,
      showEdit,
      showDelete,
      showExpand,
      deleteRowIcon,
      editForm,
      editFormName,
      hideCopyRow,
      disableDeleteFn,
      disableEditFn,
      ExpandComponent,
      rootObject,
      prepareFormatRowParamsFn,
      editOverrideFn,
      copyRowObjectFn,
      onEditFormLoad,
    } = this.props;

    if (!item) {
      return <div key={index} className="md-grid-row md-grid-row-load" />;
    }

    let rowObject = item.rowObject;

    let disableDelete = disableDeleteFn ? disableDeleteFn(rowObject) : false;
    let disableEdit = disableEditFn ? disableEditFn(rowObject) : false;

    let rowClass = item.expanded ? "" : "md-grid-row";

    let selected = grid.selectedRowIds.has(item.rowId);
    if (selected) {
      rowClass += " md-grid-row-selected";
    }

    let form =
      rowObject && editFormName ? rowObject.getForm(editFormName) : null;

    if (grid.isEditable() && form && form.$open) {
      return (
        <EditFormComp
          gridComp={this}
          editForm={editForm}
          item={item}
          key={index}
          editFormName={editFormName}
          grid={grid}
          hideCopyRow={hideCopyRow}
          onDeleteRow={this.onDeleteRow}
          rootObject={rootObject}
          prepareFormatRowParamsFn={prepareFormatRowParamsFn}
          editOverrideFn={editOverrideFn}
          copyRowObjectFn={copyRowObjectFn}
          onEditFormLoad={onEditFormLoad}
        />
      );
    } else {
      return (
        <div key={index} className={rowClass}>
          {grid.showSelection ? (
            <div
              className="md-grid-cell"
              style={{
                float: "left",
                minWidth: "28px",
                width: "28px",
                paddingTop: 2,
              }}
            >
              {!item.aggregateType ? (
                <MdCheckbox
                  name="selectRowCheckbox"
                  checked={selected}
                  onClick={this.onClickRow.bind(this, item.rowId)}
                />
              ) : null}
            </div>
          ) : (
            ""
          )}

          {showEdit ? (
            <div
              className="md-grid-cell"
              style={{ float: "left", minWidth: 20, width: 20 }}
            >
              {!item.aggregateType ? (
                <IconButton
                  onClick={this.onEditRow.bind(this, item)}
                  tooltip="Edit"
                  style={{
                    height: item.rowHeight,
                    width: 20,
                    padding: "4px 0",
                  }}
                  disabled={disableEdit}
                  iconStyle={
                    rowObject.$dirty
                      ? { fontSize: 13, color: pink500 }
                      : {
                          fontSize: 13,
                          color: grey700,
                        }
                  }
                >
                  <FontIcon className="fa fa-pencil" />
                </IconButton>
              ) : null}
            </div>
          ) : (
            ""
          )}
          {showDelete ? (
            <div
              className="md-grid-cell"
              style={{ float: "left", minWidth: 24, width: 24 }}
            >
              {!item.aggregateType ? (
                <IconButton
                  onClick={this.onDeleteRow.bind(this, [item])}
                  tooltip={"Delete"}
                  disabled={disableDelete}
                  style={{
                    height: item.rowHeight,
                    width: 24,
                    padding: "4px 4px 4px 0",
                  }}
                  iconStyle={{ fontSize: 13, color: grey700 }}
                >
                  <FontIcon className={deleteRowIcon} />
                </IconButton>
              ) : null}
            </div>
          ) : (
            ""
          )}
          {showExpand ? (
            <div
              className="md-grid-cell"
              style={{ float: "left", minWidth: 20, width: 20 }}
            >
              {!item.aggregateType ? (
                <IconButton
                  onClick={this.onExpandRow.bind(this, item.rowId)}
                  style={{ height: ROW_HEIGHT, width: 20, padding: "4px 0" }}
                  iconStyle={{ fontSize: 13, color: grey700 }}
                >
                  {item.expanded ? (
                    <FontIcon className="fa fa-caret-down" />
                  ) : (
                    <FontIcon className="fa fa-caret-right" />
                  )}
                </IconButton>
              ) : null}
            </div>
          ) : (
            ""
          )}

          <div
            className="md-grid-data-row"
            style={{
              marginRight:
                (grid.showSelection ? 28 : 0) +
                (showEdit ? 20 : 0) +
                (showDelete ? 24 : 0) +
                (showExpand ? 24 : 0),
            }}
          >
            {item.cells.map((gridCell, columnIndex) =>
              this.renderCell(item, gridCell, columnIndex)
            )}
            {item.expanded && ExpandComponent ? (
              <ExpandWrapperComp
                ExpandComponent={ExpandComponent}
                gridComp={this}
                item={item}
              />
            ) : null}
          </div>
        </div>
      );
    }
  };

  onAction = (item: GridRow, id: ID, columnIndex: number, evt: any) => {
    let { grid } = this.props;

    let field = grid.activeGridConfig.columns[columnIndex].field;

    //console.debug("functionName %s ... %s ... %s ... %s", functionName, cellId, index, evt.target.checked);
    this.props.functionMap[field.functionName](id, item, evt.target.checked);
  };

  onCheck = (item: GridRow, id: ID, columnIndex: number, evt: any) => {
    let { grid } = this.props;

    let field = grid.activeGridConfig.columns[columnIndex].field;

    //console.debug("functionName %s ... %s ... %s ... %s", functionName, cellId, index, evt.target.checked);
    this.props.functionMap[field.functionNameSetter()](
      id,
      item,
      evt.target.checked
    );
  };

  renderCell = (item: GridRow, gridCell: GridCell, columnIndex: number) => {
    let { grid, functionMap } = this.props;

    let field = grid.activeGridConfig.columns[columnIndex].field;
    if (!field) return <div />;

    let formattedValue = field.formatValue(gridCell.value);
    if (item.aggregateType && formattedValue != null && formattedValue !== "") {
      formattedValue =
        AGGREGATETYPE_MAP[item.aggregateType].glyph + "\u00A0" + formattedValue;
    }
    if (field.dataType === DATATYPE.BOOLEAN) {
      formattedValue =
        formattedValue === "true" ? (
          <SvgDone size={18} />
        ) : formattedValue === "false" ? (
          <SvgClear size={18} />
        ) : (
          formattedValue
        );
    }

    let customRoute = field.detailRoute && gridCell.dataId != null;

    let columnWidths = grid.activeGridWidths;
    let styleObject = {
      width: columnWidths[0][columnIndex] + "%",
      minWidth: columnWidths[1][columnIndex] + "px",
      maxWidth: columnWidths[2][columnIndex] + "px",
      textAlign: field.textAlign ? field.textAlign : undefined,
    };

    let css = "md-grid-cell";
    if (!customRoute) css += " no-a";
    if (gridCell.cssClass) css += " " + gridCell.cssClass;

    let route = customRoute
      ? field.detailRoute
      : field.$entityRef
      ? field.$entityRef.detailRoute
      : undefined;
    let id = customRoute ? gridCell.dataId : item.rowId;

    return field.displayType || id == null || !route ? (
      <div key={columnIndex} className={css} style={styleObject} title={gridCell.tooltip}>
        {field.displayType === DISPLAYTYPE.BUTTON ? (
          <FlatButton
            primary
            style={{ height: ROW_HEIGHT, lineHeight: ROW_HEIGHT + "px" }}
            label={gridCell.value}
            labelPosition="after"
            onClick={this.onAction.bind(this, item, id, columnIndex)}
          />
        ) : field.displayType === DISPLAYTYPE.CHECKBOX ? (
          <MdCheckbox
            name={field.fieldName}
            checked={functionMap[field.functionNameGetter()](id, item)}
            onCheck={this.onCheck.bind(this, item, id, columnIndex)}
          />
        ) : field.displayType === DISPLAYTYPE.ICON ? (
          <IconButton
            onClick={this.onAction.bind(this, item, id, columnIndex)}
            tooltip={field.label}
            style={BUTTON_STYLE}
            iconStyle={ICON_STYLE}
          >
            <FontIcon className={gridCell.glyph} />
          </IconButton>
        ) : (
          ( (typeof formattedValue === 'string' || formattedValue instanceof String) && formattedValue.startsWith("https://") ) ? <a href={formattedValue as string}>{formattedValue}</a> : formattedValue
        )
        }
      </div>
    ) : (
      <Link
        key={columnIndex}
        className={css}
        style={styleObject}
        to={route}
        params={{ id }}
        title={gridCell.tooltip}
        query={addTenantToQuery({ gridLocation: grid.gridLocation })}
      >
        {" "}
        {formattedValue}{" "}
      </Link>
    );
  };
}

const GridSelectMenuItem__li_a_style = { paddingRight: 15 };

@observer
class GridSelectMenuItem extends React.Component<
  { gc: GridConfig; route: string; onSelect: Function; onSetDefault: Function },
  undefined
> {
  onClick = (evt) => {
    evt.preventDefault();
    this.props.onSelect(evt, this.props.gc);
  };

  onClick2 = (evt) => {
    evt.preventDefault();
    this.props.onSetDefault(evt, this.props.gc);
  };

  render() {
    let { gc, route } = this.props;

    return (
      <li style={{ display: "flex", justifyContent: "space-between" }}>
        <a
          role="menuitem"
          tabIndex={-1}
          href={route}
          onClick={this.onClick}
          style={{ flexGrow: 1 }}
        >
          {gc.label}
        </a>
        <a
          href=""
          onClick={this.onClick2}
          style={GridSelectMenuItem__li_a_style}
        >
          {gc.defaultGrid ? <FaBookmark /> : <FaBookmarkO />}
        </a>
      </li>
    );
  }
}

interface EditFormCompProps {
  gridComp: GridComp;
  editForm: React.ReactElement<FormProps<DomainAncestor, DomainAncestor>>;
  item: GridRow;
  hideCopyRow: boolean;
  grid: Grid;
  editFormName: string;
  onDeleteRow: (toDeleteRows: GridRow[]) => any;
  rootObject: DomainAncestor;
  // funkce, ktera pripravi paramObject pro formatRow call,
  // prepareFormatRowParamsFn(rootObject, rowObject)
  prepareFormatRowParamsFn?: Function;

  // pro clientGrid, kdy se pri editaci radku posila cely rootObject
  // editOverrideFn(rootObject, rowObject)
  editOverrideFn?: (
    rootObject: DomainAncestor,
    modifiedRows: GridRow[],
    toDeleteRows: GridRow[]
  ) => any;

  // funkce se zavola pri kopirovani rowObjectu pri kopirovani polozky editacniho gridu
  copyRowObjectFn?: Function;

  // funkce ktera se zavola pri etevreni editovatelneho radku, musi vracet promise
  // onEditFormLoad(rowObject) : Promise<RowObject>
  onEditFormLoad?: (rowObject: DomainAncestor) => Promise<DomainAncestor>;
}

@observer
class EditFormComp extends React.Component<EditFormCompProps, undefined> {
  private formRef;

  componentDidMount() {
    //console.log('%c %s EditFormComp componentDidMount', 'background-color: red', this.props.editFormName);
    this.setRowHeight();
  }

  // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
  componentDidUpdate(prevProps, prevState) {
    //console.log('%c %s  EditFormComp componentDidUpdate', 'background-color: red', this.props.editFormName);
    this.setRowHeight();
  }

  setRowHeight() {
    let { item, gridComp } = this.props;

    if (this.formRef) {
      let rec: ClientRect = this.formRef.getBoundingClientRect();
      if (rec) {
        item.rowHeight = rec.height;
      }
    }
    //console.log("setRowHeight: rowProps.gridRow.rowHeight = " + item.rowHeight);

    gridComp.forceUpdate();
  }

  @action onRollbackRow = (evt) => {
    evt.stopPropagation();

    let { grid, editFormName, item, gridComp, onDeleteRow } = this.props;

    console.log("onRollbackRow %O", item);

    let form = item.rowObject.getForm(editFormName);
    form.$open = false;

    if (item.rowObject.$added) {
      onDeleteRow([item]);
    } else {
      item.rowObject = form.$pristineObject;
    }

    form.$pristineObject = undefined;

    item.rowHeight = ROW_HEIGHT;
    gridComp.forceUpdate();
  };

  @action onCommitRow = (evt) => {
    evt.stopPropagation();

    let { item, gridComp } = this.props;

    console.log("onCommitRow %O", item);

    return this.onCommitRowInner(item)
      .then((result) => {
        gridComp.forceUpdate();
      })
      .catch((error) => {});
  };

  @action onCommitRowInner = (item) => {
    let {
      grid,
      editFormName,
      rootObject,
      editOverrideFn,
      prepareFormatRowParamsFn,
    } = this.props;
    let rowObject = item.rowObject;

    let form = rowObject.getForm(editFormName);
    let res = form.validateForm(rowObject);

    // pro explicitne zadefinovane nestedForms (nasobne radky, ktere nejsou samostatne)
    if (form.nestedForms) {
      for (let nestedFormDef of form.nestedForms) {
        let nestedObject = get(rowObject, nestedFormDef.path);
        callOnObjectOrArray(nestedObject, (obj) => {
          let nestedForm = (obj as DomainAncestor).getForm(
            nestedFormDef.formName
          );
          let resN = nestedForm.validateForm(obj);
          res = res && resN;
        });
      }
    }

    if (!res) {
      return Promise.reject(new Error("VALIDATION_ERROR"));
    }

    if (editOverrideFn) {
      form.$open = false; // zkusime zavrit hned (invoice only zatim)
      return editOverrideFn(rootObject, [item], null).then(
        action("editOverrideFn-actionCb", () => {
          form.$open = false;
          grid.$dirty = true;
          form.$pristineObject = undefined;
          console.log(
            "onCommit - after editOverrideFn rootObject = %O",
            rootObject
          );
          item.rowHeight = ROW_HEIGHT;
          return item;
        })
      );
    } else {
      let paramSpec = Object.assign(
        { masterId: grid.masterId },
        prepareFormatRowParamsFn
          ? prepareFormatRowParamsFn(rootObject, rowObject)
          : null
      );

      return GridService.formatRow(
        grid.activeGridConfig.gridId,
        rowObject,
        paramSpec
      ).then((gridRow) => {
        item.cells = gridRow.cells;

        // OK
        form.$open = false;
        rowObject.$added = undefined;
        rowObject.$dirty = true;
        grid.$dirty = true;
        rootObject.$dirty = true;
        form.$pristineObject = undefined;
        console.log("onCommitInner - after formatRow %o", rowObject);
        item.rowHeight = ROW_HEIGHT;
        return item;
      });
    }
  };

  @action onCopyRow = (evt) => {
    evt.stopPropagation();

    let {
      grid,
      editFormName,
      rootObject,
      onEditFormLoad,
      copyRowObjectFn,
      item,
      gridComp,
    } = this.props;

    console.log("onCopyRow %O", item);

    return this.onCommitRowInner(item)
      .then((result) => {
        let newRowObject: DomainAncestor = item.rowObject.cloneDeep();
        newRowObject.$formMap.clear();
        newRowObject.$added = true;
        newRowObject.$new = true;

        newRowObject = copyRowObjectFn(newRowObject);

        grid.addRow(newRowObject);

        return onEditFormLoad
          ? onEditFormLoad(newRowObject)
          : Promise.resolve(newRowObject);
      })
      .then((rowObject) => {
        let form = rowObject.getForm(editFormName);

        form.$open = true;
        //form.$pristineObject = cloneDeep(newRowObject);
        rootObject.$dirty = true;
        grid.$dirty = true;

        gridComp.forceUpdate();
        return 1;
      })
      .catch((error) => {});
  };

  formRefHandler = (comp) => (this.formRef = comp);

  render() {
    let { editForm, item, hideCopyRow } = this.props;

    let clonedForm = React.cloneElement(editForm, {
      dataObject: item.rowObject,
    });

    return (
      <form ref={this.formRefHandler}>
        <div className="md-item--open">
          {clonedForm}
          <SvgDone
            className="active-item--check  zz-mr-15"
            size={24}
            onClick={this.onCommitRow}
          />
          <SvgClear
            className="active-item--check"
            size={24}
            onClick={this.onRollbackRow}
          />
          {hideCopyRow ? null : (
            <FaCopy
              className="active-item--check zz-ml-15"
              size={18}
              onClick={this.onCopyRow}
            />
          )}
        </div>
      </form>
    );
  }
}

interface ExpandWrapperCompProps {
  gridComp: GridComp;
  ExpandComponent?: React.ComponentClass<ExpandComponentProps>;
  item: GridRow;
}

@observer
class ExpandWrapperComp extends React.Component<
  ExpandWrapperCompProps,
  undefined
> {
  private expandoRef;

  componentDidMount() {
    //console.log('%c %s EditFormComp componentDidMount', 'background-color: red', this.props.editFormName);
    this.setRowHeight();
  }

  // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
  componentDidUpdate(prevProps, prevState) {
    //console.log('%c %s  EditFormComp componentDidUpdate', 'background-color: red', this.props.editFormName);
    this.setRowHeight();
  }

  setRowHeight() {
    let { item, gridComp } = this.props;

    if (this.expandoRef) {
      let rec: ClientRect = this.expandoRef.getBoundingClientRect();
      if (rec) {
        item.rowHeight = rec.height + ROW_HEIGHT + 8;
      }
    }
    console.log("setRowHeight: rowProps.gridRow.rowHeight = " + item.rowHeight);

    gridComp.forceUpdate();
  }

  expandoRefHandler = (comp) => (this.expandoRef = comp);

  render() {
    let { ExpandComponent, item } = this.props;
    return (
      <div ref={this.expandoRefHandler}>
        <ExpandComponent item={item} />
      </div>
    );
  }
}

interface ChartButtonProps {
  onClickChart: Function;
  showChart: boolean;
  grid?: Grid;
}

const ChartButton = (props: ChartButtonProps): JSX.Element => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "top",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <MdIconButton
        onClick={props.onClickChart}
        style={{
          width: 28,
          height: 40,
          padding: "8px 2px",
          verticalAlign: "top",
        }}
        iconStyle={GridComp__iconStyle}
        disabled={props.grid.loading}
      >
        {props.showChart ? <MdChartPie /> : <MdChartPieOutlined />}
      </MdIconButton>
      {(!!props.grid.selectedRowIds.size || props.grid.selectedAllRows) && (
        <div
          style={{
            display: "inline-block",
            marginRight: 10,
            marginBottom: 2,
          }}
        >{`(${
          props.grid.selectedAllRows
            ? props.grid.getTotalCount()
            : props.grid.selectedRowIds.size
        })`}</div>
      )}
    </div>
  );
};

interface ChartIconOverlayProps {
  showExceedChartRows: boolean;
  onShowExceedChartRowsChange: (show: boolean) => void;
  onClickChart: Function;
  grid: Grid;
  showChart: boolean;
  loadingNewRowsIds: boolean;
  selectFirstRows: (e: any, onSelected: () => void) => void;
  selectedForChart: number;
  onSelectedForChartChange: (value: number) => void;
  maxChartRows: number;
}

class ChartIconOverlay extends React.Component<ChartIconOverlayProps> {
  boundHadleWindowClick = this.hadleWindowClick.bind(this);

  hadleWindowClick() {
    if (this.props.showExceedChartRows) {
      this.props.onShowExceedChartRowsChange(false);
    }
  }

  componentDidMount() {
    window.addEventListener("click", this.boundHadleWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.boundHadleWindowClick);
  }

  render() {
    const p = this.props;
    const isSQLQueryGrid =
      p.grid.$gridLocationRef.gridType === GRIDTYPE.SQLQUERY;

    return p.showExceedChartRows ? (
      //necessary workaround. OverlayTrigger in bootstrap version 0.33 does have `show` property private
      <OverlayTrigger
        trigger={isSQLQueryGrid ? "hover" : "click"}
        defaultOverlayShown={true}
        key={"graph-botom-popover-overlay"}
        placement={"bottom"}
        overlay={
          <Popover
            id={"graph-botom-popover-overlay"}
            className="graph-button-popover"
            title={loc.i18n`chart.rowExceed`}
            onClick={(e) => e.stopPropagation()}
          >
            {p.loadingNewRowsIds ? (
              <div className="rows-ids-loader">
                <div>{loc.i18n`chart.fetchingIds`}</div>
                <LoadingIcon />
              </div>
            ) : isSQLQueryGrid ? (
              <div
                style={{ padding: "8px 14px", maxWidth: 250 }}
              >{loc.i18n`chart.pleaseFilter500`}</div>
            ) : (
              <div style={{ display: "flex" }}>
                <div>
                  <MuiMenuItem
                    onClick={(e) => {
                      p.selectFirstRows(e, () => {
                        p.onShowExceedChartRowsChange(false);
                      });
                    }}
                  >
                    {loc.i18n`chart.selectTop`}
                  </MuiMenuItem>
                  <MuiMenuItem
                    onClick={(e) => {
                      p.selectFirstRows(e, () => {
                        p.onClickChart()
                        p.onShowExceedChartRowsChange(false);
                      });
                    }}
                  >
                    {loc.i18n`chart.goTo`}
                  </MuiMenuItem>
                </div>

                <TextField
                  id="chart-rows-text-field"
                  type="number"
                  style={{ width: 50, margin: "auto" }}
                  min={0}
                  max={p.maxChartRows}
                  value={p.selectedForChart}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value > p.maxChartRows) value = p.maxChartRows;
                    if (value < 1 && value != "") value = 1;
                    p.onSelectedForChartChange(value);
                  }}
                  onBlur={(e) => {
                    if (!e.target.value) p.onSelectedForChartChange(1);
                  }}
                />
              </div>
            )}
          </Popover>
        }
      >
        <ChartButton
          onClickChart={p.onClickChart}
          showChart={p.showChart}
          grid={this.props.grid}
        />
      </OverlayTrigger>
    ) : (
      <ChartButton
        onClickChart={p.onClickChart}
        showChart={p.showChart}
        grid={this.props.grid}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/grid/component/gridComp.tsx